/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RefreshToken } from './RefreshToken';
import {
    RefreshTokenFromJSON,
    RefreshTokenFromJSONTyped,
    RefreshTokenToJSON,
} from './RefreshToken';

/**
 * 
 * @export
 * @interface RefreshTokenResponse
 */
export interface RefreshTokenResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RefreshTokenResponse
     */
    status: boolean;
    /**
     * 
     * @type {number}
     * @memberof RefreshTokenResponse
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {RefreshToken}
     * @memberof RefreshTokenResponse
     */
    data?: RefreshToken;
}

/**
 * Check if a given object implements the RefreshTokenResponse interface.
 */
export function instanceOfRefreshTokenResponse(value: object): boolean {
    if (!('status' in value)) return false;
    if (!('statusCode' in value)) return false;
    return true;
}

export function RefreshTokenResponseFromJSON(json: any): RefreshTokenResponse {
    return RefreshTokenResponseFromJSONTyped(json, false);
}

export function RefreshTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'statusCode': json['status_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'data': json['data'] == null ? undefined : RefreshTokenFromJSON(json['data']),
    };
}

export function RefreshTokenResponseToJSON(value?: RefreshTokenResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'status_code': value['statusCode'],
        'error_message': value['errorMessage'],
        'data': RefreshTokenToJSON(value['data']),
    };
}

